import React from 'react'
import './Service.css';
import Footer from '../Footer/footer';

function Service() {
  return (
<div>
    <div className='container-services'>
        <h1 className='services-title'>Weight Management</h1>
        <p className='services-description1'>
        Tired of trying to reach your weight management goals on your own without success?
        Let our dietitian help you personalize the best dietary approach for you
        </p>
        <h3 className='services-title2'>Weight Loss</h3>
        <ul className='list-services'>
            <li className='list-services-item'>Macronutrient Count</li>
            <li className='list-services-item'>Ketogenic</li>
            <li className='list-services-item'>Intermittent Fasting</li>
        </ul>
        <h3 className='services-title2'>Weight Gain</h3>
        <ul className='list-services'>
            <li className='list-services-item'>Muscle building</li>
            <li className='list-services-item'>Undeweight</li>
        </ul>
        <hr/>
        <h1 className='services-title'>Wellness</h1>
        <p className='services-description1'>
        Need help with improving your overall health or lowering bio metric numbers such as cholesterol? 
        <br/>Are you suffering from inflammation and the symptoms of inflammation, such as swollen joints or 
        fatigue? Make an appointment today to get personalized assistance in the following conditions:
        </p>
        <ul className='list-services'>
            <li className='list-services-item'>Anti-Inflammatory</li>
            <li className='list-services-item'>Vegetarian/vegan</li>
            <li className='list-services-item'>Intermittent Fasting</li>
            <li className='list-services-item'>Energy/Focus</li>
            <li className='list-services-item'>Clean Eating</li>
            <li className='list-services-item'>Food Allergies/Intolerance</li>
            <li className='list-services-item'>Chronic Disease Control <br/>* Diabetes
<br/>* High Cholesterol</li>
            <li className='list-services-item'>High Blood Pressure</li>
            <li className='list-services-item'>IBS</li>
            <li className='list-services-item'>Woman's Health<br/>* PCOS
            <br/>* Fertility</li>
            <li className='list-services-item'>Hormonal Balance</li>
            <li className='list-services-item'>Nutrigenomics</li>
        </ul>
        <hr/>
        <h1 className='services-title'>Performance</h1>
        <p className='services-description1'>
        Nutrition plays a key role in athletic performance. Whatever your sport is, 
        let our dietitian help you strategize the best nutrition plan for your training and competing.
        </p>
        <ul className='list-services'>
            <li className='list-services-item'>Pre/Post Workout Nutrition</li>
            <li className='list-services-item'>Competitions</li>
            <li className='list-services-item'>Endurance Sports</li>
            <li className='list-services-item'>Team Sports</li>
        </ul>
        <hr/>
        <h1 className='services-title'> Children and Teens</h1>
        <p className='services-description1'>
        Does your child have a nutrition need? Let our Houstonian dietitian guide you and your child in the right nutrition direction. 
        If you have a picky eater, one of the best strategies to diversify your child's food choices is using a method called Food Chaining. 
        Call our dietitian today to get more information.
        </p>
        <ul className='list-services'>
				<li className='list-services-item'>Weight management</li>
				<li className='list-services-item'>Picky eating</li>
				<li className='list-services-item'>Special diets</li>
				<li className='list-services-item'>Food Allergies &amp; Intolerances</li>
				<li className='list-services-item'>Athletic nutrition</li>
			</ul>
    </div>
            <Footer />

            </div>
  )
}

export default Service